import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import EigenwijsOptionControls from "features/option-controls/eigenwijs-option-controls";
import Icon, { IconTypes } from "shared/ui/icon";
import Heading from "shared/ui/typography/Heading";
import { LayoutNavigationTransition } from "widgets/configurator/layout-navigation-transition";
import { OptionModalState } from "../option-modal";
import { GroupedLayoutSelector } from "./components/GroupedLayoutSelector";
import { DoorOptionsControlsList } from "./components/door-options-controls-list";
import { SelectionWrapper } from "./SelectionWrapper";
import {
  getClassicLayoutGroup,
  getLayoutBrowseGroup,
} from "entities/configurator/model/layoutMeta";
import { useLayoutNavigationFocus } from "./hooks/useLayoutNavigationFocus";

interface DoorOptionsControlsProps {
  setOptionModalState: (state: OptionModalState) => void;
  showMeasurementInputs?: boolean;
}

export const DoorOptionsControls = ({
  setOptionModalState,
  showMeasurementInputs = false,
}: DoorOptionsControlsProps) => {
  const { groupedLayouts, selectedDoor } = useConfigurationOptionsContext();
  const groupCode = groupedLayouts?.[0]?.code;
  const group = getLayoutBrowseGroup(groupCode);
  const isClassicLayoutGroup = getClassicLayoutGroup(groupCode) !== null;
  const { focusContent, onClickCapture } = useLayoutNavigationFocus(
    group,
    selectedDoor?.code,
  );
  const layoutViewKey = groupCode ?? "DoorOptionsControlsList";
  const groupClassName = isClassicLayoutGroup
    ? "gg-w-full gg-max-w-md"
    : undefined;
  return (
    <>
      <Heading headingLevel="h4" className="gg-flex">
        Kies een ontwerp
        <button
          data-testid="option-info-button"
          aria-label="Meer informatie over ontwerpen"
          onClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: "Kies een ontwerp",
              description:
                "Selecteer en pas aan of begin met een lege deur om je eigen ontwerp samen te kunnen stellen.",
            })
          }
        >
          <Icon name={IconTypes.INFO} className="gg-ml-2" alt="" />
        </button>
      </Heading>

      <SelectionWrapper className="gg-pt-4">
        <LayoutNavigationTransition
          viewKey={layoutViewKey}
          className={groupClassName}
          focusContent={focusContent}
          onClickCapture={onClickCapture}
        >
          {groupedLayouts ? (
            <GroupedLayoutSelector layouts={groupedLayouts} />
          ) : (
            <DoorOptionsControlsList />
          )}
        </LayoutNavigationTransition>
        <EigenwijsOptionControls
          showMeasurementInputs={showMeasurementInputs}
        />
      </SelectionWrapper>
    </>
  );
};
